import Box from '@mui/material/Box';
import { SearchField } from '@openx/design-system/components/SearchField/SearchField.tsx';
import { useTranslation } from 'react-i18next';
import { OpenXAgentSelect } from '../../shared/OpenXAgentSelect.tsx';
import { DealType } from '../utils/consts.ts';

type MatchedDomainAppToolbarProps = {
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  dealType: DealType;
  onDealTypeChange: (dealType: DealType) => void;
};

export const MatchedDomainAppToolbar = ({
  searchQuery,
  onSearchQueryChange,
  dealType,
  onDealTypeChange,
}: MatchedDomainAppToolbarProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', gap: 1, mt: 1.5 }}>
      <SearchField
        value={searchQuery}
        onChange={event => onSearchQueryChange(event.target.value)}
        placeholder={t('Search')}
        inputLabel={t('Search domains and app bundles')}
        slotProps={{ htmlInput: { 'data-test': 'openx-agent-matched-domain-app-search' } }}
        sx={{ flex: '0 1 240px', minWidth: 120 }}
      />

      <OpenXAgentSelect
        value={dealType}
        onChange={onDealTypeChange}
        ariaLabel={t('Deal type')}
        dataTest="openx-agent-matched-domain-app-deal-type"
        options={[
          { value: DealType.DIRECT, label: t('Direct') },
          { value: DealType.OPEN_MARKET, label: t('Open Market') },
        ]}
      />
    </Box>
  );
};
